// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_Pfu8r","sub_logo":"index_sub_logo_zDJwy","breadcrumbs":"index_breadcrumbs_AruPt"};